const UniversityList = [
  { name: "서울시립대학교", address_lat: 37.5825812, address_lon: 127.0600071 },
  {
    name: "서울여자간호대학교",
    address_lat: 37.5976681,
    address_lon: 126.9476147,
  },
  { name: "서울여자대학교", address_lat: 37.6280329, address_lon: 127.0904235 },
  { name: "서일대학교", address_lat: 37.5861321, address_lon: 127.097475 },
  { name: "성공회대학교", address_lat: 37.4877973, address_lon: 126.8255597 },
  { name: "성균관대학교", address_lat: 37.5879535, address_lon: 126.9921594 },
  { name: "성신여자대학교", address_lat: 37.5923265, address_lon: 127.0212298 },
  { name: "세종대학교", address_lat: 37.5514705, address_lon: 127.0738839 },
  { name: "숙명여자대학교", address_lat: 37.5459469, address_lon: 126.9645778 },
  { name: "숭실대학교", address_lat: 37.4960751, address_lon: 126.9581433 },
  { name: "숭의여자대학교", address_lat: 37.5570678, address_lon: 126.987521 },
  { name: "연세대학교", address_lat: 37.567113, address_lon: 126.9390291 },
  { name: "이화여자대학교", address_lat: 37.5606017, address_lon: 126.9478377 },
  { name: "인덕대학교", address_lat: 37.630813, address_lon: 127.0550871 },
  {
    name: "장로회신학대학교",
    address_lat: 37.5498747,
    address_lon: 127.1033079,
  },
  { name: "적십자간호대학", address_lat: 37.5674167, address_lon: 126.96635 },
  {
    name: "중앙대학교 서울캠퍼스",
    address_lat: 37.5048875,
    address_lon: 126.9573779,
  },
  { name: "총신대학교", address_lat: 37.4907585, address_lon: 126.9671368 },
  { name: "추계예술대학교", address_lat: 37.5630397, address_lon: 126.9536152 },
  {
    name: "한국방송통신대학교",
    address_lat: 37.5793538,
    address_lon: 127.0033287,
  },
  { name: "한국성서대학교", address_lat: 37.648778, address_lon: 127.0643529 },
  {
    name: "한국예술종합학교",
    address_lat: 37.6129569,
    address_lon: 127.0614129,
  },
  {
    name: "한국외국어대학교",
    address_lat: 37.5973078,
    address_lon: 127.0582878,
  },
  { name: "한국체육대학교", address_lat: 37.5198884, address_lon: 127.1308626 },
  {
    name: "한국폴리텍 I 대학 서울강서캠퍼스",
    address_lat: 37.5503996,
    address_lon: 126.8435681,
  },
  {
    name: "한국폴리텍Ⅰ대학 서울정수캠퍼스",
    address_lat: 37.5287699,
    address_lon: 126.9965892,
  },
  { name: "한성대학교", address_lat: 37.5825084, address_lon: 127.0102929 },
  { name: "한양대학교", address_lat: 37.5545036, address_lon: 127.0466112 },
  { name: "한양여자대학교", address_lat: 37.5590124, address_lon: 127.0497272 },
  { name: "한영신학대학교", address_lat: 37.4966286, address_lon: 126.8507649 },
  { name: "홍익대학교", address_lat: 37.5482766, address_lon: 126.9223875 },
  { name: "가톨릭대학교", address_lat: 37.5000798, address_lon: 127.0052599 },
  { name: "가톨릭대학교", address_lat: 37.5859764, address_lon: 127.0043558 },
  {
    name: "감리교신학대학교",
    address_lat: 37.5675717,
    address_lon: 126.9621585,
  },
  { name: "건국대학교", address_lat: 37.5408421, address_lon: 127.0793152 },
  { name: "경기대학교", address_lat: 37.5649767, address_lon: 126.9623605 },
  { name: "경희대학교", address_lat: 37.5964494, address_lon: 127.0525009 },
  { name: "고려대학교", address_lat: 37.5899102, address_lon: 127.0318121 },
  { name: "광운대학교", address_lat: 37.6197044, address_lon: 127.059678 },
  { name: "국민대학교", address_lat: 37.6121866, address_lon: 126.995341 },
  { name: "국제예술대학", address_lat: 37.5169114, address_lon: 127.0310249 },
  { name: "그리스도대학교", address_lat: 37.548626, address_lon: 126.8548771 },
  { name: "덕성여자대학교", address_lat: 37.6515354, address_lon: 127.0166028 },
  { name: "동국대학교", address_lat: 37.5574704, address_lon: 127.0011519 },
  { name: "동덕여자대학교", address_lat: 37.6051787, address_lon: 127.046681 },
  { name: "동양미래대학교", address_lat: 37.5009475, address_lon: 126.8675318 },
  {
    name: "디지털서울문화예술대학교",
    address_lat: 37.5853994,
    address_lon: 126.9439038,
  },
  {
    name: "명지대학교 인문캠퍼스",
    address_lat: 37.5802367,
    address_lon: 126.9231244,
  },
  { name: "명지전문대학", address_lat: 37.5846502, address_lon: 126.9254007 },
  { name: "배화여자대학교", address_lat: 37.5791763, address_lon: 126.9658922 },
  { name: "백석예술대학교", address_lat: 37.4801726, address_lon: 126.9962892 },
  {
    name: "사이버한국외국어대학교",
    address_lat: 37.5973078,
    address_lon: 127.0582878,
  },
  { name: "삼육대학교", address_lat: 37.6429794, address_lon: 127.1042695 },
  { name: "삼육보건대학교", address_lat: 37.5902092, address_lon: 127.0685787 },
  { name: "상명대학교", address_lat: 37.6035329, address_lon: 126.9560283 },
  { name: "서강대학교", address_lat: 37.5527065, address_lon: 126.9392056 },
  { name: "서경대학교", address_lat: 37.6150457, address_lon: 127.0133575 },
  {
    name: "서울과학기술대학교",
    address_lat: 37.6316216,
    address_lon: 127.0783722,
  },
  {
    name: "서울과학기술대학교",
    address_lat: 37.6316217,
    address_lon: 127.0783723,
  },
  { name: "서울교육대학교", address_lat: 37.4907061, address_lon: 127.0154373 },
  { name: "서울기독대학교", address_lat: 37.6008716, address_lon: 126.9125713 },
  { name: "서울대학교", address_lat: 37.4552733, address_lon: 126.9543348 },
  {
    name: "서울디지털대학교",
    address_lat: 37.5429699,
    address_lon: 126.9478585,
  },
  {
    name: "서울사이버대학교",
    address_lat: 37.6299155,
    address_lon: 127.0271207,
  },
];

export default UniversityList;
